import { render } from "./Menue.vue?vue&type=template&id=bf8ea916"
import script from "./Menue.vue?vue&type=script&lang=js"
export * from "./Menue.vue?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-runner/builds/Bv4wyByn/0/ben/social-share.link/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__